const isDev = false
const devHost = 'http://127.0.0.1:7097'
const releaseHost = 'https://draw-server.tgbcanvas.com'
const host = isDev ? devHost : releaseHost

// const defaultToken = 'KLGg7wTkNF1VF1jRfb45'
const tokenPrefix = 'KLGg7wTkNF1VF1jRfb45'

export {
    host,
    tokenPrefix,
}